import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const TooltipModal = ({ text, title }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="link" className='tooltip-btn' onClick={handleShow}>
        <i className="tooltip-question">i</i>
      </Button>

      <Modal className='modal-tooltip' show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {text}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TooltipModal;
